import { BorderRadius, Color } from '@billy/design-system'
import styled from '@emotion/styled'

export const PreviewWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  min-width: 0;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  border: 1px solid ${Color.Grey150};
  border-radius: 0 ${BorderRadius.R12} ${BorderRadius.R12} 0;
  background-color: ${Color.Grey100};
  overflow-x: hidden;
  overflow-y: auto;
`
